import { render, staticRenderFns } from "./LectureList.vue?vue&type=template&id=7687b548&"
import script from "./LectureList.vue?vue&type=script&lang=ts&"
export * from "./LectureList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports